const USE_STAGING = false;
const NON_PRODUCTION_SERVER = USE_STAGING ? 'http://54.37.195.161' : 'http://localhost:8888';

export default {
  AUTH_API_URL: 'https://www.progettieducativi.it/api/v0/sessions/',

  AUTH_USER_TYPE_ADMIN: 'adm',
  AUTH_USER_TYPE_PROJECT_MANAGER: 'pm',
  AUTH_USER_TYPE_EDU: 'edu',
  AUTH_USER_TYPE_MARKETING: 'mkt',

  V1_API_URL: window.location.hostname == 'https://v1.api.progettieducativi.it/api/v1',
  V1_API_STATUS_REFUSED: 'refused',
  V1_API_STATUS_ON_HOLD: 'on_hold',

  V2_API_URL: 'https://api.progettieducativi.it/api/v2',

  V3_API_URL: window.location.hostname == 'localhost' && 1 ? NON_PRODUCTION_SERVER + '/api/v3' : 'https://api.progettieducativi.it/api/v3',

  LOCATIONS_API_URL: window.location.hostname == 'localhost' && 0 ? 'http://localhost:5555/api/v1' : 'https://locations-api.dev.progettieducativi.it/api/v1',
  LOCATIONS_API_ACCESS_TOKEN: 'LOC_BN78FGHiH839X',

  MAILGUN_FROM: 'Librì Progetti Educativi <scuola@progettiedu.it>'
};



// WEBPACK FOOTER //
// ./src/config.js